import React from 'react';
import styled from 'styled-components';

import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

const Title = ({ title }) => <Wrap>{title}</Wrap>;

export default Title;

const Wrap = styled.div`
  ${flexbox({
    alignItems: 'center',
  })}

  width: 215px;
  padding: 15px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.primary.dark};

  ${mediaQueries.fromAndBelow.tablet`
    width: initial;
    max-width: 170px;
  `}
`;
